// extracted by mini-css-extract-plugin
export default {"cls1":"fgGquMj63anS4TdHpPfj","cls2":"_FoXxNsgEv3ZPzDvbK6U fgGquMj63anS4TdHpPfj"};